import { render, staticRenderFns } from "./supportcompany.vue?vue&type=template&id=3f035db0&scoped=true"
import script from "./supportcompany.vue?vue&type=script&lang=js"
export * from "./supportcompany.vue?vue&type=script&lang=js"
import style0 from "./supportcompany.vue?vue&type=style&index=0&id=3f035db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f035db0",
  null
  
)

export default component.exports